import { useQuery } from "@tanstack/react-query";

import { appointmentsApi } from "@/api";
import { QueryKey } from "@/query/Query";

/**
 * Every appointment colleagues have marked for takeover: the rows of the "Zu übernehmen" tab, and
 * the figure both that tab's badge and the sidebar badge show. Sending no counselor is what
 * tells this list apart from useCounselorAppointmentsQuery at the shared endpoint.
 */
export function useTakeoverQuery() {
  return useQuery({
    queryKey: [QueryKey.AppointmentTakeovers],
    queryFn: () => appointmentsApi.getAppointmentsForTakeover(),
  });
}
